import {
  CompetitionGroup,
  EsportOffering,
  EsportRating,
  EsportV2,
  Platform,
} from '@plvs/graphql/generated'

export enum TeamType {
  Private = 'Private',
  Standard = 'Standard',
}

export type EsportCardType = {
  slug: string | null | undefined
  name: string
  esportGroupId: string
}

export type EsportConfig = {
  competitionGroupOptions: Array<{
    id: string
    competitionGroup: CompetitionGroup
  }>
  rating: EsportRating | null
  platformOptions: Array<Platform | null>
  teamSizeOptions: Array<number>
  esportGroupId: string
  name: string
  esportSlug: string | undefined
}

export type UserCreateTeam = {
  name: string
  isCoachForOrg: boolean
  id: string
  organization: {
    id: string
    competitionGroup: CompetitionGroup | null | undefined
    name: string
  } | null
}

export interface CreateTeamFormInput {
  competitionGroup?: {
    id?: string
    competitionGroup: CompetitionGroup | null
  }
  size: number
  name: string
  selectedEsportGroupId: string
  type: TeamType
}

export type CompetitionGroupOption = {
  value: string
  label: CompetitionGroup
}

export type PlatformOption = {
  value: Platform | null
  label: Platform | null
}
export type TeamFormatOption = { value: number; label: number }

export type FormOptions = {
  competitionGroupOptions: Array<CompetitionGroupOption>
  teamSizeOptions: Array<TeamFormatOption>
}

export interface GetEsportV2ConfigProps {
  esportV2: Pick<EsportV2, 'id' | 'name' | 'rating'> & {
    offerings:
      | Pick<
          EsportOffering,
          'competitionGroup' | 'esportId' | 'platform' | 'teamFormat'
        >[]
      | null
  }
  schoolData: {
    id: string
    competitionGroup: CompetitionGroup | null | undefined
  }
  esportSlug: string | undefined
}
